import classNames from "classnames";
import Link from "next/link";
import type { ShopDetailNameArea_ShopFragment } from "@components/ShopDetail/NameArea/__generated__/fragments";
import ShopRating from "@components/ShopRating";
import ShopRatingToolTip from "@components/ShopRatingToolTip";
import { paths } from "@libs/paths";
import { IFImg } from "@libs/utils/IFImg";
import { createGoogleMapAppUrl } from "@libs/utils/map";
import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  shop: ShopDetailNameArea_ShopFragment;
};

const NameArea: FC<Props> = ({ shop }) => {
  return (
    <div className={styles.nameArea}>
      <div className={styles.nameAreaInner}>
        <ShopDetailName shop={shop} />
        <div className={styles.ratingArea}>
          <ShopRating
            shouldShowRating={shop.shopRating?.shouldShowRating || false}
            rating={shop.shopRating?.ratingCalculated}
            ratingCount={shop.shopRating?.ratingCount}
          />
          <ShopRatingToolTip shopUuid={shop.uuid} />
        </div>
      </div>
      <ShopDetailMapIcon
        link={createGoogleMapAppUrl({
          prefecture: shop.masterPrefecture.name,
          city: shop.city,
          block: shop.block,
          building: shop.building,
          name: shop.name,
        })}
      />
    </div>
  );
};

const ShopDetailName: FC<Props> = ({
  shop: { name, uuid, masterShopGenre, closestStation, closestStationTime },
}) => {
  return (
    <>
      <div className={classNames(styles.name, "md:none")}>{name}</div>
      <div className={classNames(styles.name, "none md:block")}>
        <Link href={paths.shopDetail(uuid)} legacyBehavior>
          {name}
        </Link>
      </div>
      <div className={styles.info}>
        {masterShopGenre.name} / {closestStation}駅徒歩{closestStationTime}分
      </div>
    </>
  );
};

type MapIconProps = {
  link: string;
};

const ShopDetailMapIcon: FC<MapIconProps> = ({ link }) => {
  return (
    <a href={link} className={styles.iconMap} target={"_blank"}>
      <img src={IFImg("/img/icon_map.png")} alt="" />
    </a>
  );
};

export default NameArea;
